import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableLtlRegistration = (): boolean => {
  return useFeatureFlag(FeatureFlagDeclarations.enableLtlRegistration);
};
